import type { QuestionModule } from "../contracts";
import {
  maxDiffCore,
  type MaxDiffDefinition,
  type MaxDiffDraft,
  type MaxDiffEvent,
  type MaxDiffRaw,
  type MaxDiffResponse,
} from "./core";
import { MaxDiffView } from "./views";

export const maxDiffModule: QuestionModule<
  MaxDiffRaw,
  MaxDiffDefinition,
  MaxDiffDraft,
  MaxDiffEvent,
  MaxDiffResponse
> = {
  type: "max_diff",
  galleryFeatures: [
    "baseline",
    "pairs",
    "images",
    "row-images",
    "restored",
    "dont-know",
  ],
  core: maxDiffCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Pair",
      component: MaxDiffView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
